import request from "./request";

const brokerage = {
  service() {
    return {
      list(params) {
        params.pageIndex = params.pageIndex ? params.pageIndex : 0;
        params.pageSize = params.pageSize ? params.pageSize : 10;
        params.sort = params.sort ? params.sort : "name,ASC";

        return request
          .get("/agents-api/brokerages", params)
          .then((resp) => {
            return {
              resp: resp,
              filter: params.name ? params.name : "",
              productFamily: params.productFamily ? params.productFamily : "",
            };
          })
          .catch((e) => {
            throw e;
          });
      },
      get(id) {
        return request.get(`/agents-api/brokerages/${id}`, null);
      },
      stats(brokerage) {
        return request.get(
          `/agents-api/brokerages/${brokerage.id}/stats`,
          null,
        );
      },
      referrals(brokerage, params) {
        // return request.get(
        //   `/agents-api/brokerages/${brokerage.id}/referrals`,
        //   params
        // );

        return request
          .get(`/agents-api/brokerages/${brokerage.id}/referrals`, params)
          .then((resp) => {
            return {
              resp: resp,
              filter: params,
            };
          })
          .catch((e) => {
            throw e;
          });
      },
      agentInvitationStats(id, params) {
        return request.get(
          `/agents-api/brokerages/${id}/agentInvitations/stats`,
          params,
        );
      },
      getNotes(params) {
        return request.get(`/agents-api/brokerNotes`, params);
      },
      postNote(data) {
        return request.post(`/agents-api/brokerNotes`, data);
      },
      getProductFamilyItems() {
        return request.get(`/agents-api/product`);
      },
      getApiNationStatus(id) {
        return request.get(`/agents-api/brokerages/${id}/apination`);
      },
      enableApiNation(id) {
        return request.post(
          `/agents-api/brokerages/${id}/apination/enable`,
          null,
        );
      },
      disableApiNation(id) {
        return request.post(
          `/agents-api/brokerages/${id}/apination/disable`,
          null,
        );
      },
    };
  },
};

export default brokerage;
